export const GetterTypes = {
  STYLES: "STYLES",
  IMAGES: "IMAGES",
  META: "META",
  __CURRENT_THEME__: "__CURRENT_THEME__",
  __THEMES__: "__THEMES__"
}
